import { render } from "./ComplianceSubmissionDialog.vue?vue&type=template&id=7c37cd81&scoped=true"
import script from "./ComplianceSubmissionDialog.vue?vue&type=script&lang=js"
export * from "./ComplianceSubmissionDialog.vue?vue&type=script&lang=js"

import "./ComplianceSubmissionDialog.vue?vue&type=style&index=0&id=7c37cd81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c37cd81"]])

export default __exports__